// Restricted (c) Siemens Healthineers AG, 2025, All rights reserved.

import { Injectable } from '@angular/core';
import { getServersHealth } from '../../../api/remote-api/.dnasyngovia.generated/fn/syngo-via-health-scoring/get-servers-health';
import { getNetworkConnections } from '../../../api/remote-api/.dnasyngovia.generated/fn/syngo-via-network/get-network-connections';
import {
  createIssueTicket,
  CreateIssueTicket$Params,
} from '../../../api/remote-api/.dnasyngovia.generated/fn/syngo-via-issues/create-issue-ticket';
import { MapApiService } from '../../shared/services/map-api.service';
import { APICallState } from '../../shared/utils/api-call-state.util';
import { IssueTicketCreatedOutput } from 'src/app/api/remote-api/.dnasyngovia.generated/models/issue-ticket-created-output';

@Injectable({
  providedIn: 'root',
})
export class DnaSyngoviaService {
  public constructor(private readonly mapApiService: MapApiService) {}

  public selectedServerHealthcheck: string | undefined;

  public getServersHealth = this.mapApiService.mapEndpoint(getServersHealth);

  public getNetworkConnections = this.mapApiService.mapEndpoint(
    getNetworkConnections
  );

  public createIssueTicket = this.mapApiService.mapEndpoint(createIssueTicket);

  public get createIssueTicketNewInstance(): APICallState<
    CreateIssueTicket$Params,
    IssueTicketCreatedOutput,
    CreateIssueTicket$Params
  > {
    return this.mapApiService.mapEndpoint(createIssueTicket);
  }
}
